import React from 'react'
// components
import { Modal } from 'components/UI'
import ObjectiveColorPickerForm from './Form'
// context
import { ObjectiveContext } from 'context/index'
// constants
import { Modals } from 'constants/index'
// hooks
import { useModalData } from 'hooks/index'

const ObjectiveColorPickerModal: React.FC = () => {
  const { entity, planTypeLevel, update } = React.useContext(ObjectiveContext) as any

  const {
    hideModal,
    modalData: { isOpen }
  } = useModalData({ modalType: Modals.OBJECTIVE_SET_COLOR_MODAL })

  const handleFormSubmit = async (data) => {
    try {
      await update({
        variables: {
          id: entity.id,
          input: {
            color: data.color
          }
        }
      })

      hideModal()
    } catch (error) {
      console.log('[ObjectiveColorPickerModal.handleFormSubmit]: ', error)
    }
  }

  const initialValues = { color: entity.color || planTypeLevel.color }

  return (
    <Modal isOpen={isOpen} width='sm' hideModal={hideModal}>
      <ObjectiveColorPickerForm initialValues={initialValues} onSubmit={handleFormSubmit} hideModal={hideModal} />
    </Modal>
  )
}

export default ObjectiveColorPickerModal
